import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Minimal layout that only renders the child route.
 * Used as parent for both the main app (with sidebar in App) and /app (native webview, no sidebar).
 * Sidebar visibility is controlled in App based on the URL path.
 */
@Component({
  selector: 'app-shell-layout',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>',
})
export class ShellLayoutComponent {}
